import { Breadcrumb, Container, Loading } from "components";
import { FormattedMessage, useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { convertRawToHtml } from "utils";
import { useSingleLaboratoryAnalysis } from "./hooks/useSingleLaboratoryAnalysis";

import "./LaboratoryAnalysis.scss";

export function LaboratoryAnalysis() {
  const { formatMessage } = useIntl();

  const { id } = useParams();

  const { laboratoryAnalsysis } = useSingleLaboratoryAnalysis(id as string);

  if (!laboratoryAnalsysis) return <Loading />;

  return (
    <Container>
      <div className="laboratory-analysis">
        <Breadcrumb
          className="laboratory-analysis__breadcrumb"
          links={[
            {
              label: formatMessage({
                id: "main.breadcrumb",
                defaultMessage: "_main.breadcrumb_"
              }),
              value: "/"
            },
            {
              label: formatMessage({
                id: "laboratory.breadcrumb",
                defaultMessage: "_laboratory.breadcrumb_"
              }),
              value: "/laboratory"
            },
            {
              label: laboratoryAnalsysis?.title || "",
              value: laboratoryAnalsysis?.title || ""
            }
          ]}
        />
        <div className="laboratory-analysis__header">
          {/* <FormattedMessage
            id="laboratory-analysis.title"
            defaultMessage="_analysis-name_"
          /> */}
        </div>
        <h1 className="laboratory-analysis__title">
          {laboratoryAnalsysis?.title}
        </h1>
        <div className="laboratory-analysis__content">
          {convertRawToHtml(laboratoryAnalsysis?.content)}
        </div>
      </div>
    </Container>
  );
}
